import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

import Header from 'src/components/Header';
import RegisterButton from 'src/components/RegisterButton';
import TabContent from 'src/components/TabContent/TabContent';
import ScrollAnimation from 'src/components/ScrollAnimation';

import data from 'src/data/team';
import imgHeader from 'src/assets/images/team/team-hero-skyllensign.jpg';
import imgSkyllen from 'src/assets/images/team/skyllen-logo.png';
import imgCompleted1 from 'src/assets/images/team/1650-onsecond.jpg';
import imgCompleted2 from 'src/assets/images/team/building-view-team.jpg';
import imgBackgroundCircle from 'src/assets/images/bg-circle-grey.svg';

class Team extends Component {
  render() {
    return (
      <Root>
        <Header image={imgHeader} smallText={'The'} largeText={'Team'} />
        <ScrollAnimation>
          <BackgroundCircle
            src={imgBackgroundCircle}
            alt="background circle"
            top={'37%'}
            left={'0%'}
          />
          <BackgroundCircle
            src={imgBackgroundCircle}
            alt="background circle"
            top={'25%'}
            left={'85%'}
            size={'30%'}
          />
          <BackgroundCircle
            src={imgBackgroundCircle}
            alt="background circle"
            top={'52%'}
            left={'58%'}
            size={'20%'}
          />
          <BackgroundCircle
            src={imgBackgroundCircle}
            alt="background circle"
            top={'75%'}
            left={'-18%'}
            size={'40%'}
          />
          <Content>
            <img src={imgSkyllen} alt="Skyllen Pacific" className="logo" />
            <h1>Inspiration, Collaboration, Innovation</h1>
            <p>
              <span>Skyllen Pacific</span> is a multi-disciplinary real estate
              development company based in Vancouver, valuing{' '}
              <span>strategic locations</span> and <span>smart design</span> to{' '}
              <span>craft high-quality, sustainable developments</span>.
              Inspired by the dynamic vitality of emerging cityscapes and
              collaborating with communities to discover enduring solutions,
              Skyllen Pacific cultivates innovative solutions to transform
              housing into homes. The firm’s commitment to constructing and
              articulating urban policies set the{' '}
              <span>template for innovation</span>, leading to{' '}
              <span>master-planned developments</span> that radiate livability
              and modern convenience.
            </p>
            <Button href="https://www.skyllenpacific.com/" target="_blank">
              Visit Skyllen Pacific{' '}
              <img src={require('src/assets/images/arrow-right.svg')} alt="" />
            </Button>
            <h1>1650 on Second</h1>
            <p className="no-margin">West 2nd Avenue, Vancouver</p>
            <h4>Completed 2017</h4>
            <Projects>
              <img src={imgCompleted1} alt="West 2nd Avenue, Vancouver" />
              <img src={imgCompleted2} alt="West 2nd Avenue, Vancouver" />
            </Projects>
          </Content>
          <h1>Visionary Collaboration, Practical Experience</h1>
          <TabContent tabData={data} />
          <RegisterButton />
        </ScrollAnimation>
      </Root>
    );
  }
}

export default Team;

const Root = styled.div`
  overflow: hidden;
  position: relative;
  h1 {
    text-transform: uppercase;
    margin: 0 auto;
    width: 90%;
    @media (min-width: ${media.smup}) {
    }
  }
  .no-margin {
    margin: 0 auto;
  }
  h4 {
    font-size: 12px;
    font-weight: normal;
    color: ${({ theme }) => theme.colorPrimary};
    margin-top: 20px;
  }
`;

const Content = styled.div`
  margin: 100px auto 50px;
  width: 90%;
  text-align: center;
  position: relative;
  @media (min-width: ${media.smup}) {
    width: 85.4%;
    margin: 100px auto 180px;
  }
  .logo {
    height: 60px;
    margin-bottom: 60px;
    @media (min-width: ${media.smup}) {
      height: 100px;
    }
  }
  h1 {
    text-transform: uppercase;
    @media (min-width: ${media.mdup}) {
      white-space: nowrap;
      margin: 0 auto;
    }
  }
  p {
    font-family: ${({ theme }) => theme.fontMain};
    font-size: 18px;
    color: rgba(0, 0, 0, 0.72);
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    margin: 20px 0;
    @media (min-width: ${media.mdup}) {
      max-width: 811px;
      margin: 30px auto 40px;
    }
  }
  span {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

const Projects = styled.div`
  width: 100%;
  display: block;
  margin: 30px auto 10px;
  img {
    width: 100%;
  }
  @media (min-width: ${media.smup}) {
    display: flex;
    justify-content: space-between;
    img {
      width: 49%;
      object-fit: cover;
    }
  }
  @media (min-width: ${media.mdup}) {
    width: 85.4%;
    /* img {
      width: 600px;
      height: 367px;
      object-fit: cover;
    } */
  }
`;

const BackgroundCircle = styled.img`
  position: absolute;
  top: ${props => props.top};
  left: ${props => props.left};
  z-index: -1;
  width: ${props => props.size};
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const Button = styled.a`
  width: 183.8px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: white;
  border-radius: 17.5px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontHeader};
  font-weight: 500;
  color: rgba(0, 0, 0, 0.83);
  margin: 0 auto 130px;
  @media (min-width: ${media.smup}) {
    margin: 0 auto 180px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Team.js